namespace Solovis.Reports {

    type ManagerLinkInfo = { managerId?: number, resourceId?: number }

    export class ReportLinkerClient {

        private _portalServices: Solovis.Portal.IPortalServices;

        constructor(portalServices?: Solovis.Portal.IPortalServices) {
            if (portalServices) {
                this._portalServices = portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }
        }

        public getReportLink(reportOptions) {
            var options: any = {};

            if (reportOptions.parameters) {
                options.parameters = reportOptions.parameters;
            }

            if (reportOptions.persistedSettings) {
                options.persistedSettings = reportOptions.persistedSettings;
            }

            if (reportOptions.autoRun) {
                options.autoRun = true;
            }

            if (reportOptions.collapseConfigSection) {
                options.collapseConfigSection = true;
            }

            var jsonOptions = JSON.stringify(options);
            var jsonOptionsBase64 = Solovis.Base64.encode(jsonOptions);

            var url = Solovis.resolveUrl("~/ReportData/ViewReport?", this._portalServices.siteUrl());

            if (reportOptions.reportCode) {
                url += "reportCode=" + encodeURIComponent(reportOptions.reportCode);
            }
            else if (reportOptions.reportAlias) {
                url += "reportAlias=" + encodeURIComponent(reportOptions.reportAlias);
            }
            else {
                return "javascript:alert('Error creating report link.');";
            }

            if (jsonOptionsBase64) {
                url += "#?options=" + encodeURIComponent(jsonOptionsBase64);
            }

            return url;
        }

        public getAssetLinks(entityOrInvestmentParam) {
            var links = [];

            links.push({
                label: "Asset Info",
                href: this.getReportLink({
                    reportAlias: "AssetInfo",
                    parameters: { entityOrInvestment: entityOrInvestmentParam },
                    autoRun: true,
                    collapseConfigSection: true
                })
            });

            return links;
        }

        public getEntityLinks(entity) {
            var entityParam: any = {};
            if (typeof entity == "number") {
                entityParam.entityId = entity;
            }
            else if (entity.entityId) {
                entityParam.entityId = entity.entityId;
            }
            else if (entity.resourceId) {
                entityParam.resourceId = entity.resourceId;
            }
            else {
                return [];
            }

            var links = [];

            links.push({
                label: "Entity Info",
                href: this.getReportLink({
                    reportAlias: "AssetInfo",
                    parameters: { entityOrInvestment: entityParam },
                    autoRun: true,
                    collapseConfigSection: true
                })
            });

            return links;
        }

        public getInvestmentLinks(investment) {
            var investmentParam: any = {};
            if (typeof investment == "number") {
                investmentParam.investmentId = investment;
            }
            else if (investment.investmentId) {
                investmentParam.investmentId = investment.investmentId;
            }
            else if (investment.resourceId) {
                investmentParam.resourceId = investment.resourceId;
            }
            else {
                return [];
            }

            var links = [
                {
                    label: "Investment Info",
                    href: this.getReportLink({
                        reportAlias: "AssetInfo",
                        parameters: { entityOrInvestment: investmentParam },
                        autoRun: true,
                        collapseConfigSection: true
                    })
                }
            ];

            return links;
        }

        public getTagSetLinks(tagSet) {
            if (!tagSet) {
                return [];
            }

            var tagSetId;
            if (typeof tagSet == "number") {
                tagSetId = tagSet;
            }
            else {
                if (tagSet.id) {
                    tagSetId = tagSet.id;
                }
                else if (tagSet.tagSetId) {
                    tagSetId = tagSet.tagSetId;
                }
            }

            if (tagSetId) {
                var reportCodeForTagSetData = "27168735-49B3-4C5A-B489-9F6C66D86B77";

                var links = [
                    {
                        label: "Tag Set Data",
                        href: this.getReportLink({
                            reportCode: reportCodeForTagSetData,
                            parameters: { tagSet: { tagSetId: tagSetId } },
                            autoRun: true,
                            collapseConfigSection: true
                        })
                    }
                ];

                return links;
            }
            else {
                return [];
            }
        }


        public getTagLinks(tag) {
            if (!tag) {
                return [];
            }

            var tagId;
            var tagSetId;

            if (tag.tagSetId) {
                tagSetId = tag.tagSetId;
            }
            else if (tag.tagSet) {
                tagSetId = tag.tagSet.id;
            }

            if (tag.id) {
                tagId = tag.id;
            }
            else if (tag.tagId) {
                tagId = tag.tagId;
            }

            if (tagId && tagSetId) {
                var links = [
                    {
                        label: "Tag Associations",
                        href: this.getReportLink({
                            reportAlias: "TagAssoc",
                            parameters: { tag: { tagId: tagId, tagSetId: tagSetId } },
                            autoRun: true,
                            collapseConfigSection: true
                        })
                    }
                ];

                return links;
            }
            else {
                return [];
            }
        }

        public getContactLinks(contact) {
            var contactParam: any = {};
            if (typeof contact == "number") {
                contactParam.contactId = contact;
            }
            else if (contact.contactId) {
                contactParam.contactId = contact.contactId;
            }
            else if (contact.resourceId) {
                contactParam.resourceId = contact.resourceId;
            }
            else {
                return [];
            }

            var reportCodeForContactData = "9664EF6A-420B-40CD-9DCA-52B159AF368B";

            var links = [
                {
                    label: "Contact Summary",
                    href: this.getReportLink({
                        reportAlias: "ContactSummary",
                        parameters: { contact: contactParam },
                        autoRun: true,
                        collapseConfigSection: true
                    })
                },
                {
                    label: "Contact Data",
                    href: this.getReportLink({
                        reportCode: reportCodeForContactData,
                        parameters: { contact: contactParam },
                        autoRun: true,
                        collapseConfigSection: true
                    })
                }
            ];

            return links;
        }

        public getNoteLinks(note) {
            var noteParam: any = {};
            if (typeof note == "number") {
                noteParam.noteId = note;
            }
            else if (note.noteId) {
                noteParam.noteId = note.noteId;
            }
            else if (note.resourceId) {
                noteParam.resourceId = note.resourceId;
            }
            else {
                return [];
            }

            var reportCodeForNoteSummary = "0BD819F1-A463-4F5B-A5D4-1F9DB2B95C43";
            var reportCodeForNoteData = "DFBC71DB-BA04-4CFF-8509-CFFD2F9E3D45";

            var links = [
                {
                    label: "Note Summary",
                    href: this.getReportLink({
                        reportCode: reportCodeForNoteSummary,
                        parameters: { note: noteParam },
                        autoRun: true,
                        collapseConfigSection: true
                    })
                },
                {
                    label: "Note Data",
                    href: this.getReportLink({
                        reportCode: reportCodeForNoteData,
                        parameters: { note: noteParam },
                        autoRun: true,
                        collapseConfigSection: true
                    })
                }
            ];

            return links;
        }

        public getTransactionLinks(transaction, more?) {
            var transactionParam: any = {};
            if (typeof transaction == "number") {
                transactionParam.transactionId = transaction;
            }
            else if (transaction.transactionId) {
                transactionParam.transactionId = transaction.transactionId;
            }
            else if (transaction.resourceId) {
                transactionParam.resourceId = transaction.resourceId;
            }
            else {
                return [];
            }

            var reportCodeForTransactionEntry = "5031BAD2-1F5C-4DB3-8DA4-62475EC5FB46";
            var reportCodeForTransactionHistory = "5F6E9E2A-ECC9-4301-8AC1-3FB1B1254D52";

            var links = [];

            if (transactionParam.transactionId && !this._portalServices.isProxiedDataEnvironment()) {
                links.push(
                    {
                        label: "View Transaction Group",
                        click: function () {
                            Solovis.ModuleLoader.modalEnsureModuleListLoaded(["Solovis.TxEditors"], function () {
                                // TODO: Replace with strongly typed reference once TxEditors is typescript module.
                                (Solovis as any).Site.TxEditors.TxUtil.showTxGroupEditorDialog({
                                    txId: transactionParam.transactionId,
                                    canEdit: false
                                });
                            });
                        }
                    });

                if (more && more.canEdit) {
                    links.push(
                        {
                            label: "Edit Transaction Group",
                            click: function () {
                                Solovis.ModuleLoader.modalEnsureModuleListLoaded(["Solovis.TxEditors"], function () {
                                    // TODO: Replace with strongly typed reference once TxEditors is typescript module.
                                    (Solovis as any).Site.TxEditors.TxUtil.showTxGroupEditorDialog({
                                        txId: transactionParam.transactionId,
                                        canEdit: true,
                                        saveCallback: function (t) {
                                            if (more && more.editSaveCallback) {
                                                more.editSaveCallback(t);
                                            }
                                        }
                                    });
                                });
                            }
                        });
                }
            }

            links.push({
                label: "Transaction Entry Details",
                href: this.getReportLink({
                    reportCode: reportCodeForTransactionEntry,
                    parameters: { transaction: transactionParam },
                    autoRun: true,
                    collapseConfigSection: true
                })
            });

            links.push({
                label: "Transaction History",
                href: this.getReportLink({
                    reportCode: reportCodeForTransactionHistory,
                    parameters: { transaction: transactionParam },
                    autoRun: true
                })
            });

            return links;
        }

        /**
         * Builds the right-click context-menu links for a row in a pro forma transaction list.
         * Mirrors getTransactionLinks but routes the View/Edit actions through the pro-forma
         * editor — the regular tx editor reads TransactionEntries by id and would return the
         * wrong row (or none) for a ProFormaTransaction id.
         */
        public getProFormaTransactionLinks(txId: number, more?: { canEdit?: boolean, locked?: boolean, grouped?: boolean, editSaveCallback?: (t: any) => void }) {
            const links: Solovis.UI.PopupLinkPanelLink[] = [];

            if (this._portalServices.isProxiedDataEnvironment()) {
                return links;
            }

            links.push({
                label: "View Pro Forma Transaction Group",
                // A grouped (Phase II scaffold) row has no investment/owner/holding of its own to
                // view here -- disabled rather than omitted, same convention as the locked case
                // below (PF2-015): no tooltip/explanation, just non-interactive.
                disabled: more && more.grouped,
                click: () => {
                    Solovis.ModuleLoader.modalEnsureModuleListLoaded(["Solovis.TxEditors"], () => {
                        (Solovis as any).Site.TxEditors.ProFormaTxUtil.showProFormaTxGroupEditorDialog({
                            txId: txId,
                            canEdit: false
                        });
                    });
                }
            });

            if (more && more.canEdit) {
                links.push({
                    label: "Edit Pro Forma Transaction Group",
                    // Locked (approved or promoted) groups render the option disabled rather than
                    // omitting it, per PF2-015 -- no tooltip/explanation, just non-interactive. A
                    // grouped (Phase II scaffold) row is disabled for the same reason: it has no
                    // investment/owner/holding of its own to edit trade legs against.
                    disabled: more.locked || more.grouped,
                    click: () => {
                        Solovis.ModuleLoader.modalEnsureModuleListLoaded(["Solovis.TxEditors"], () => {
                            (Solovis as any).Site.TxEditors.ProFormaTxUtil.showProFormaTxGroupEditorDialog({
                                txId: txId,
                                canEdit: true,
                                saveCallback: (t: any) => {
                                    if (more && more.editSaveCallback) {
                                        more.editSaveCallback(t);
                                    }
                                }
                            });
                        });
                    }
                });
            }

            return links;
        }

        public getUserLinks(user) {
            var userParam: any = {};
            if (typeof user == "number") {
                userParam.userId = user;
            }
            else if (user.userId) {
                userParam.userId = user.userId;
            }
            else if (user.resourceId) {
                userParam.resourceId = user.resourceId;
            }
            else {
                return [];
            }

            var reportCodeForUserData = "FB3230D6-E9A1-40BE-9860-78C6A57E2302";

            var links = [
                {
                    label: "User Summary",
                    href: this.getReportLink({
                        reportAlias: "UserSummary",
                        parameters: { user: userParam },
                        autoRun: true,
                        collapseConfigSection: true
                    })
                },
                {
                    label: "User Data",
                    href: this.getReportLink({
                        reportCode: reportCodeForUserData,
                        parameters: { user: userParam },
                        autoRun: true,
                        collapseConfigSection: true
                    })
                }
            ];

            return links;
        }

        public getPropertyLinks(propDef) {
            var propDefParam: any = {};
            if (typeof propDef == "number") {
                propDefParam.id = propDef;
            }
            else if (propDef.id) {
                propDefParam.id = propDef.id;
            }
            else if (propDef.resourceId) {
                propDefParam.resourceId = propDef.resourceId;
            }
            else {
                return [];
            }

            var reportCodeForPropDefData = "8060B8EB-8484-4224-9B10-C18B16C84907";

            var links = [
                {
                    label: "Property Definition Data",
                    href: this.getReportLink({
                        reportCode: reportCodeForPropDefData,
                        parameters: { property: propDefParam },
                        autoRun: true,
                        collapseConfigSection: true
                    })
                }
            ];

            return links;
        }

        public getLiquidityModelLink(modelId) {
            const links = [];

            links.push({
                label: "Liquidity Model",
                href: Solovis.resolveUrl("~/DataManagement/LiquidityModelEditor/EditLiquidityModel?id=" + modelId)
            });

            return links;
        }

        public setupSolovisRefLink(element, solovisRef) {
            Solovis.UI.PopupLinkPanel.onElementClick(element, function (e) {
                var solovisRefToUse;
                if (typeof solovisRef == "function") {
                    solovisRefToUse = solovisRef();
                }
                else {
                    solovisRefToUse = solovisRef;
                }

                var type = solovisRefToUse.type;
                var value = solovisRefToUse.value;

                var links = null;

                if (type == "entity") {
                    links = this.getEntityLinks(value);
                }
                else if (type == "investment") {
                    links = this.getInvestmentLinks(value);
                }
                else if (type == "entityOrInvestment") {
                    links = this.getAssetLinks(value);
                }

                if (!_.isEmpty(links)) {
                    Solovis.UI.PopupLinkPanel.showLinks({
                        links: links,
                        offset: { left: e.pageX, top: e.pageY }
                    });
                }
            });

            Solovis.Site.DragDropManager.setupSolovisRefDrag(element, solovisRef);
        }

        public getManagerLink(manager: number | ManagerLinkInfo) {
            var managerParam: ManagerLinkInfo = {};
            if (typeof manager == "number") {
                managerParam.managerId = manager;
            }
            else if (manager.managerId) {
                managerParam.managerId = manager.managerId;
            }
            else if (manager.resourceId) {
                managerParam.resourceId = manager.resourceId;
            }
            else {
                throw ("Can't Create manager link without proper information.");
            }

            return Solovis.resolveUrl("~/jumpto/gotomanager?id=" + (managerParam.managerId || "") + "&resourceid=" + (managerParam.resourceId || ""), this._portalServices.siteUrl());
        }

        public getManagerLinks(manager: number | ManagerLinkInfo) {
            try {
                var links = [
                    {
                        label: "Manager Info",
                        href: this.getManagerLink(manager),
                    }
                ];

                return links;
            } catch (error) {
                console.error(error);
                return [];
            }
        }
    }

    export const ReportLinker = new ReportLinkerClient();
}